<template>
  <div class="material-select hmd-btn">
    <a-button type="primary" @click="showModal">{{ buttonText }}</a-button>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { LibraryListRecord } from "@/views/material/library/library.interface";
import CategoryTree from "./category-tree/index.vue";
import MaterialTable from "./material-table/index.vue";
import SelectedTable from "./selected-table/index.vue";
import { hmdConfirm } from "@/dialog/index";

/**
 * 材料选择
 *
 * 使用方法:
 * <material-select v-model:value="<string[]>"></material-select>
 */
export default defineComponent({
  name: "MaterialSelect",
  components: {
    CategoryTree,
    MaterialTable,
    SelectedTable,
  },
  props: {
    buttonText: {
      type: String,
      default: "选择材料",
    },
    value: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    hideColumn: {
      type: Array as PropType<any[]>,
      default: () => [],
    },
  },
  emits: ["update:value", "change"],
  setup(props, { attrs, slots, emit }) {
    const state = reactive<{
      currentMaterialCategoryId: string;
      currentMaterialList: LibraryListRecord[];
    }>({
      currentMaterialCategoryId: "",
      currentMaterialList: [],
    });

    const showModal = () => {
      hmdConfirm({
        com: import("./dialog.vue"),
        params: {
          //@ts-ignore
          projectWorkPlanId:props.projectWorkPlanId,
          hideColumn:props.hideColumn
        },
        zIndex:100,
        confirm:({res})=>{
          let {ids,currentMaterialList}=res
          emit("update:value", ids);
          emit("change", currentMaterialList);
        }
      });
    };

    const closeModal = () => {
      state.currentMaterialList = [];
    };

    const ok = () => {
      const ids = state.currentMaterialList.map((item) => item.id);
      if (ids.length === 0) {
        message.warning("请选择材料，加入待选列表");
        return;
      }
      emit("update:value", ids);
      emit("change", state.currentMaterialList);
      closeModal();
    };

    return {
      ...toRefs(state),
      showModal,
      closeModal,
      ok,
    };
  },
});
</script>

<style lang="less" scoped>
.material-select {
  display: inline-block;
}
</style>

<style lang="less">
.material-select__modal {
  position: relative;
  /* padding: 0 415px 0 265px; */
  max-height: 850px;

  &__left,
  &__right {
    /* position: absolute;
    top: 0;
    height: 100%;
    overflow-y: auto; */
  }

  /* &__left {
    left: 0;
    width: 250px;
  }

  &__right {
    right: 0;
    width: 450px;
  } */
}
</style>
